import { z } from 'zod';
import { BaseSchema } from '../base/base.entity.model';
import * as FlatModels from '../../internal';

export const DashArray = [
  {
    name: 'Standardwert',
    value: null,
  },
  {
    name: 'Durchgezogen',
    value: '1,0',
  },
  {
    name: 'Gepunktet',
    value: '2,4',
  },
  {
    name: 'Gestrichelt',
    value: '10,4',
  }
];

export const FreeFormStyleSchema = BaseSchema.extend({
  height: z.number(),
  width: z.number(),
  strokeWidth: z.number().nullable().default(null),
  closePath: z.boolean().nullable().default(null),
  smooth: z.boolean().default(false),
  background: z.boolean().default(false),
  backgroundInBorderColor: z.boolean().default(false),
  strokeColor: z.string().max(255).nullable().default(null),
  opacity: z.number().nullable().default(null),
  startType: FlatModels.AnnotationEntityModels.TipType.nullable().default(FlatModels.AnnotationEntityModels.TipType.enum.none),
  endType: FlatModels.AnnotationEntityModels.TipType.nullable().default(FlatModels.AnnotationEntityModels.TipType.enum.none),
  endRadius: z.number().nullable().default(null),
  startRadius: z.number().nullable().default(null),
  color: z.string().max(255).nullable().default(null),
  dash: z.string().nullable().default(null),

  // Not yet in database
  angle: z.number().nullable().default(null),
  smoothFactor: z.number().default(0.3),
  freeForm: z.string().uuid().optional()
});

export type FreeFormStyle = z.infer<typeof FreeFormStyleSchema>;

export const FreeFormStyleEntityQueryResultSchema = FlatModels.EntityControlModels.EntityQueryResultSchema.extend({
  entity: FreeFormStyleSchema,
});

export type FreeFormStyleEntityQueryResult = z.infer<typeof FreeFormStyleEntityQueryResultSchema>;
